export default __webpack_public_path__ + "static/media/tmz.4c3c473f.jpg";